var _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.571533,
    y: 0.857178,
    width: 30,
    height: 30,
    rx: 10,
    fill: "#28A138"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    transform: "translate(7 7.28577)",
    fill: "#28A138"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4166_70158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 18,
    height: 18
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.28577,
    width: 17.1429,
    height: 17.1429,
    fill: "#16205B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4166_70158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5715 15.8571C14.7857 15.8571 14.1131 15.5773 13.5536 15.0178C12.9941 14.4583 12.7143 13.7857 12.7143 13C12.7143 12.2143 12.9941 11.5416 13.5536 10.9821C14.1131 10.4226 14.7857 10.1428 15.5715 10.1428C16.3572 10.1428 17.0298 10.4226 17.5893 10.9821C18.1488 11.5416 18.4286 12.2143 18.4286 13C18.4286 13.7857 18.1488 14.4583 17.5893 15.0178C17.0298 15.5773 16.3572 15.8571 15.5715 15.8571ZM10.5715 21.5714C10.3691 21.5714 10.1996 21.5028 10.0629 21.3657C9.92575 21.229 9.85718 21.0595 9.85718 20.8571V19.5714C9.85718 19.1666 9.96146 18.7945 10.17 18.455C10.3781 18.1159 10.6548 17.8571 11 17.6785C11.7381 17.3095 12.4881 17.0326 13.25 16.8478C14.0119 16.6635 14.7857 16.5714 15.5715 16.5714C16.3572 16.5714 17.131 16.6635 17.8929 16.8478C18.6548 17.0326 19.4048 17.3095 20.1429 17.6785C20.4881 17.8571 20.7648 18.1159 20.9729 18.455C21.1815 18.7945 21.2857 19.1666 21.2857 19.5714V20.8571C21.2857 21.0595 21.2172 21.229 21.08 21.3657C20.9434 21.5028 20.7738 21.5714 20.5715 21.5714H10.5715Z",
    fill: "#FAFAFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRegistration);
export default __webpack_public_path__ + "static/media/activeRegistration.5fcb9da484883f73a06e4ce65612ea9d.svg";
export { ForwardRef as ReactComponent };